import { TbPlayerPlayFilled } from "react-icons/tb";
import styles from "./VideoSection.module.css";

// Pôster servido de public/ (~107 KB) — referenciado via PUBLIC_URL para não
// entrar no bundle do webpack. Padrão CRA.
const POSTER_SRC = `${process.env.PUBLIC_URL}/video-apresentacao-poster.jpg`;

const HEADING_ID = "video-apresentacao-title";

/**
 * Subtítulo padrão. Promete agenda ("agenda e confirma") — o que é verdade na
 * Home e em `/agendamento`, e é FALSO em `/atendimento`, cujo tier não agenda,
 * não remarca, não cancela e não envia lembrete de agenda.
 */
const DEFAULT_SUBTITLE =
  "Sem enrolação: como o robô atende, agenda e confirma pelo seu negócio.";

/**
 * VideoSection — seção da landing que convida o visitante a assistir ao vídeo
 * de apresentação. Renderiza apenas o pôster (facade); o embed do YouTube só
 * é montado depois, dentro do VideoModal, quando o usuário clica no play.
 *
 * @param {Function} onPlay - Callback disparado ao clicar no card (abre o modal).
 * @param {string} [subtitle=DEFAULT_SUBTITLE] - Texto abaixo do H2. Existe
 *   porque o default promete agenda: a Home e `/agendamento` usam o default e
 *   dizem a verdade; `/atendimento` passa uma variante sem agenda, já que
 *   aquele tier só responde no WhatsApp e no Instagram — o próprio FAQ da
 *   página diz "não mexe em agenda".
 */
const VideoSection = ({ onPlay, subtitle = DEFAULT_SUBTITLE }) => (
  <section className={styles.section} aria-labelledby={HEADING_ID}>
    <div className={styles.content}>
      <div className={styles.kickerRow}>
        <span className={styles.kicker}>Em 2 minutos</span>
      </div>

      <h2 id={HEADING_ID} className={styles.heading}>
        Veja a Nexus Tech funcionando
      </h2>

      <p className={styles.subtitle}>{subtitle}</p>

      <button
        type="button"
        className={styles.card}
        onClick={onPlay}
        aria-label="Assistir à apresentação da Nexus Tech"
      >
        <img
          className={styles.poster}
          src={POSTER_SRC}
          alt=""
          width="1280"
          height="720"
          loading="lazy"
          decoding="async"
        />
        <span className={styles.playBadge} aria-hidden="true">
          <TbPlayerPlayFilled className={styles.playIcon} />
        </span>
      </button>

      <p className={styles.note}>
        O vídeo carrega só quando você clica — a página continua rápida.
      </p>
    </div>
  </section>
);

export default VideoSection;
